import { InjectionToken } from '@angular/core';

import {
  Authenticator,
  CommandQueueRunner,
  DatabaseCreator,
  IndexRebuilder,
  MaintenanceSynchroniser,
  MaintenanceWatchStarter,
  ProduktlyInitializer,
  RootHistorySetter,
  ShutdownInfoListener,
  SyncIndicatorCloser,
  SyncIndicatorOpener,
  SyncIndicatorPreCloser,
  SyncStarter,
  TokenHandler,
  WebSyncStarter,
} from '../contracts/sync/sync-endpoints';

export const syncOrder = [
  SyncIndicatorPreCloser,
  TokenHandler,
  Authenticator,
  DatabaseCreator,
  SyncIndicatorOpener,
  IndexRebuilder,
  MaintenanceSynchroniser,
  MaintenanceWatchStarter,
  ShutdownInfoListener,
  CommandQueueRunner,
  RootHistorySetter,
  SyncStarter,
  WebSyncStarter,
  SyncIndicatorCloser,
  ProduktlyInitializer,
];

export const SyncOrderToken = new InjectionToken<string[]>('SyncOrder', {
  providedIn: 'root',
  factory: () => syncOrder,
});
